<script setup>
import { XMarkIcon } from "@heroicons/vue/24/solid";

const props = defineProps({
  align: {
    type: String,
    default: "left",
    required: false,
  },
});
</script>

<template>
  <div
    class="flex items-center p-4"
    :class="{
      'justify-start': props.align === 'left',
      'justify-center text-center': props.align === 'center',
      'justify-end': props.align === 'right',
    }"
  >
    <XMarkIcon class="size-5 text-red-500" />
  </div>
</template>
